import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  model,
  output,
  Signal,
  viewChild,
} from '@angular/core';
import { DsBoxModule, DsModalModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { PaginationProvider } from '../../../utils/pagination/pagination.provider';
import { modalOpenOrClosing } from '../../../utils/signal/modalOpenOrClosing';
import { SyncWithNscContainer } from './sync-with-nsc.container';

@Component({
  selector: 'cdf-sync-with-nsc-modal',
  imports: [SyncWithNscContainer, DsModalModule, DsBoxModule],
  providers: [PaginationProvider],
  template: `
    <ds-modal [ds-modal-trigger-for]="modal" [(isModalOpen)]="open" [isDismissable]="!isLoading()" #modal>
      <ds-box-header>
        {{ i18n('nscSync.title') }}
        <span class="text-regular text-neutral d-inline">({{ paginationProvider.stepString() }})</span>
      </ds-box-header>
      <ds-box-content>
        @if (openOrClosing()) {
          <cdf-sync-with-nsc-container
            [initialEmail]="initialEmail()"
            [accountNumber]="accountNumber()"
            [(isLoading)]="isLoading"
            (closeEvent)="open.set(false)"
            (reloadPage)="reloadPage.emit()"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  styleUrl: './sync-with-nsc-modal.wrapper.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncWithNscModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly paginationProvider = inject(PaginationProvider);

  readonly open = model(false);
  readonly accountNumber = input.required<string>();
  readonly initialEmail = input<string | undefined>();
  readonly isLoading = model(false);
  readonly reloadPage = output();

  readonly modal: Signal<ElementRef<HTMLElement>> = viewChild.required('modal', { read: ElementRef });
  protected readonly openOrClosing = modalOpenOrClosing(this.open, this.modal);
}
